var map = {
	"./bread.jpg": 3296,
	"./breadbrown.jpg": 3031,
	"./canned.jpg": 9888,
	"./cleaning.jpg": 6706,
	"./coffeetea.jpg": 7591,
	"./crackers.jpg": 1261,
	"./eggs.jpg": 5893,
	"./fruits.jpg": 5827,
	"./fruitsexotic.jpg": 7500,
	"./garliconion.jpg": 2435,
	"./leafies.jpg": 3486,
	"./roots.jpg": 4162,
	"./spreads.jpg": 7152,
	"./staples.jpg": 4606,
	"./tofu.jpg": 7571,
	"./toilet.jpg": 6367,
	"./tooth.jpg": 4613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;